module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('div', {
    staticClass: "bodymatter",
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('h1', {
    staticClass: "chapter_fm1",
    attrs: {
      "id": "c03"
    }
  }, [_c('span', {
    staticClass: "chapter_fm1"
  }, [_vm._v("c. 2800 BCE")])]), _vm._v(" "), _c('h1', {
    staticClass: "chapter"
  }, [_vm._v("Soap")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Soapmaking may sound like a humble craft, but it’s the first chemical preparation that we have any record of. Sumerian tablets dating from 2800 BCE make mention of soap-like materials, and soap’s use in washing wool was described three hundred years later. Another Sumerian clay tablet from 2200 BCE offered a formula that would still work today: water, alkali from ashes, and oil.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Recipes of many kinds are found throughout the Egyptian, Roman, and Chinese records, but they all have the same chemistry behind them. No matter the plant or animal source, oils and fats are all triglycerides—a molecule of glycerol, also called "), _c('em', [_vm._v("glycerin")]), _vm._v(", with three long-chain fatty acids attached to it as esters. The ester groups can be broken (hydrolyzed) in the presence of a strong alkali in water. In preindustrial times, the most reliable source of alkaline compounds was extract of wood ash (which we now know contained potassium carbonate). Treating this compound with the mineral slaked lime (calcium hydroxide) led to an even more alkaline potassium hydroxide, known as “lye” or “caustic soda,” which is excellent soapmaking material.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After the hydrolysis reaction (combining with water), what’s left are free glycerol molecules and the potassium salts of the fatty acids that were attached to it. Those molecules straddle the fence when it comes to their behavior in water: The acid/salt ends are completely water-soluble, but the long carbon chains behind them are not. They attract other greasy substances, however, which are pulled along into the water by the polar salt ends—effective for degreasing wool in a Sumerian stream.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That dissolves-both-ways trick turns out to be extremely useful in a world where almost everything can be divided into the categories “dissolves in water” and “dissolves in oil.” In the twentieth century it was discovered that similar molecules (along with "), _c('strong', [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/c48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("cholesterol")])]), _vm._v(") make up the membranes of every living cell. These molecules form a bilayer, with polar water-soluble ends interacting with water-based fluids inside and outside the cell, while the long nonpolar chains in the middle of the membrane form a protective barrier. This ensures that cell contents don’t leak out and unwanted material from outside the cell doesn’t soak in.")]), _vm._v(" "), _c('p', {
    staticClass: "seealso"
  }, [_c('strong', [_vm._v("SEE ALSO")]), _vm._v(" "), _c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/c48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cholesterol (1815)")]), _vm._v(", "), _c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/c114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("pH and Indicators (1909)")]), _vm._v(", "), _c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/c196",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Isoamyl Acetate and Esters (1962)")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('div', {
    staticClass: "dis_img"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "Images/019.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Bright blues and yellows mean that a soap bubble’s thickness is down to only two hundred to three hundred nanometers (billionths of a meter), which is shorter than the wavelengths of visible light.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e6bc939","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/c03.vue
// module id = 84
// module chunks = 0